module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Virginia Heath\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("When "), _c('B', [_vm._v("Virginia Heath ")]), _vm._v("was a little girl it look her ages to fall asleep, so she made up stories in her head to pass the time while she was staring at the ceiling. As she got older, the stories became more complicated, sometimes taking weeks to get to the happy ending. Then one day, she decided to embrace the insomnia and start writing them down. Over twenty books and three Romantic Novel of the Year Award nominations later, it still takes her forever to fall asleep.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/XPitWb/tc-custom/9781488086953.jpg?1704281356074",
      "alt": "This image is the cover for the book Mysterious Lord Millcroft, The King's Elite"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Mysterious Lord Millcroft, The King's Elite\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Will she choose to live life as a duchess . . . or something much more dangerous? “A tender, sensual romance wrapped around an intriguing plot.” —"), _c('i', [_vm._v("All About Romance")])]), _c('br'), _c('br'), _vm._v("Constantly told that her beauty and charm are all she has to offer, Lady Clarissa is intent on marrying a duke. And intriguing spy Sebastian Leatham will help her. But first she’ll assist him with his new assignment—playing the part of confident aristocrat Lord Millcroft. Soon, Sebastian awakens a burning desire within Clarissa that leaves her questioning whether becoming a duchess is what she truly longs for . . . "), _c('br'), _c('br'), _vm._v("“Virginia Heath never disappoints.” —"), _c('i', [_vm._v("Romance Junkies")]), _c('br'), _c('br'), _vm._v("“[Heath’s] storytelling skills and character development are unmatched.” —"), _c('i', [_vm._v("Fresh Fiction")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0